import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FieldSelect, Text } from '@dixa/lib-shared-habla';
import { Field } from 'redux-form';
import { messengerSettingsFormFields } from 'components/settings/components/sections/dixaMessenger/views/appearance/types';
import { AnonymousDetails, ClaimedDetails, VerifiedDetails, VerifiedSettings, } from './components';
const items = [
    {
        id: 'ANONYMOUS',
        name: 'Allow anonymous users',
    },
    {
        id: 'CLAIMED',
        name: 'Allow users to claim their identity',
    },
    {
        id: 'VERIFIED',
        name: 'Programmatically authenticate the users',
    },
];
/** Authentication messenger settings. */
export function Authentication({ messengerId, minimumIdentificationLevel, }) {
    return (_jsxs(_Fragment, { children: [_jsx(Text.Heading, Object.assign({ variant: "heading-3" }, { children: "Request user identity" })), _jsx(Box, Object.assign({ margin: "300 0 0 0" }, { children: _jsx(Field, { label: "Select a method", component: FieldSelect, name: messengerSettingsFormFields.minimumIdentificationLevel, items: items }) })), minimumIdentificationLevel === 'ANONYMOUS' && _jsx(AnonymousDetails, {}), minimumIdentificationLevel === 'CLAIMED' && _jsx(ClaimedDetails, {}), minimumIdentificationLevel === 'VERIFIED' && _jsx(VerifiedDetails, {}), _jsx(VerifiedSettings, { messengerId: messengerId })] }));
}
